import { memo } from 'react';

function CancelIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="19"
			height="19"
			fill="none"
			viewBox="0 0 19 19"
			{...props}
		>
			<path
				fill="#888"
				d="m9.342 8.398 4.125-4.125 1.179 1.179-4.125 4.125 4.125 4.124-1.179 1.179-4.125-4.125-4.124 4.125-1.179-1.179 4.125-4.124-4.125-4.125 1.179-1.179z"
			></path>
		</svg>
	);
}

export default memo(CancelIcon);
